import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import ThresholdRange, { getThresholdRangeText } from '../components/ThresholdRange';

export function thresholdRangeColumn(title, lowerField, upperField) {
    return {
        title,
        field: lowerField,
        cssClass: 'threshold-range-cell',
        hozAlign: 'center',
        vertAlign: 'middle',
        width: 90,
        minWidth: 90,
        responsive: 999,
        tooltip: cell => {
            const data = cell.getData();
            return getThresholdRangeText(data[lowerField], data[upperField]);
        },
        formatter: cell => {
            const data = cell.getData();
            const lower = data[lowerField];
            const upper = data[upperField];
            return renderToStaticMarkup(<ThresholdRange lower={lower} upper={upper} />);
        },
        accessorDownload: (value, data) => getThresholdRangeText(data[lowerField], data[upperField])
    };
}
